// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class PlanningPeriod {
  readonly id: string;
  readonly planningYearId: string;
  readonly sequence: number;
  readonly startDate: DateTime;
  readonly endDate: DateTime;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.planningYearId = data.planningYearId === undefined ? NIL_UUID : data.planningYearId;
    this.sequence = data.sequence === undefined ? 0 : data.sequence;
    this.startDate = DateHelpers.ParseServerDate(data.startDate);
    this.endDate = DateHelpers.ParseServerDate(data.endDate);
  }

  static zero(): PlanningPeriod {
    const zeroValues: ExcludeMethodsDeep<PlanningPeriod> = {
      id: NIL_UUID,
      planningYearId: NIL_UUID,
      sequence: 0,
      startDate: DateHelpers.ParseServerDate(DateHelpers.ZERO_DATE_STRING),
      endDate: DateHelpers.ParseServerDate(DateHelpers.ZERO_DATE_STRING),
    };
    return new PlanningPeriod(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PlanningPeriodWireFormat = {
  id: string;
  planningYearId: string;
  sequence: number;
  startDate: string;
  endDate: string;
};

type NewPlanningPeriodProps = PartialDeep<PlanningPeriod, { recurseIntoArrays: true }>;
export const NewPlanningPeriod: (props: NewPlanningPeriodProps) => PlanningPeriod = (props) =>
  new PlanningPeriod(props);

type NewPlanningPeriodFromWireFormatProps = PartialDeep<
  PlanningPeriodWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPlanningPeriodFromWireFormat: (
  props: NewPlanningPeriodFromWireFormatProps,
) => PlanningPeriod = (props) => new PlanningPeriod(props);
